<template>
  <!-- Modale informativa con le info sugli acquisti effettuati per i parenti da visualizzare prima di far continuare l'utente -->
  <b-modal v-model="conditions_modal" title="Comunicazione" class="text-justify" size="xl"
          no-close-on-esc
          no-close-on-backdrop
          scrollable
          hide-header-close
          hide-footer>
    <b-row>
      <b-col class="alert alert-warning mr-2 ml-2" role="alert">
          <h5><b-icon icon="exclamation-triangle"></b-icon> IMPORTANTE:</h5>
          <p>Si rende noto che nel rispetto degli artt. 51 e 100 del Testo Unico Imposte sui Redditi, il beneficiario del Piano Welfare può effettuare acquisti tramite la piattaforma web nella sezione "Convenzioni special":</p>
              <p>- solo per le finalità indicate al comma 1 dell'art. 100 (educazione, istruzione, ricreazione, assistenza sociale e sanitaria o culto);</p>
              <p>- solo per sé o per i familiari indicati nell'art.433 del Codice Civile vigente, richiamato dall'art. 12 del Testo Unico Imposte sui Redditi.</p>

      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <p>Di seguito l'elenco dei soggetti che, oltre al titolare del piano welfare, possono beneficiare dei servizi acquistati:</p>
          <ul>
          <li>il coniuge (non legalmente ed effettivamente separato)</li>
          <li>i figli (legittimi o legittimati o naturali o adottivi) anche adottivi, e, in loro mancanza, i discendenti prossimi (anche naturali)</li>
          <li>i genitori e, in loro mancanza, gli ascendenti prossimo, anche naturali; gli adottanti</li>
          <li>il partner nelle unioni civili (Legge 20 maggio 2016, n.76)</li>
          <!-- <li>i generi e le nuore</li>
          <li>il suocero e la suocera</li>
          <li>i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</li> -->
          </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
          <b-form>
            <b-form-group id="group-ok-condizioni">
                <b-form-checkbox
                id="ok-condizioni"
                name="ok-condizioni"
                :value="true"
                :unchecked-value="false"
                v-model="conditions_checkbox"
                required>
                <span class="font-italic">Il/la sottoscritto/a dichiara, sotto la propria responsabilità, che i dati relativi ai familiari che verranno inseriti sulla piattaforma sono veritieri e si impegna a modificarli qualora avvenissero vicende modificative di tali dati. In caso di verifica di nominativo non appartenente all’elenco di cui sopra autorizzo Welfarebit srl ad emettere nei miei confronti regolare fattura per i servizi acquistati.</span>
                </b-form-checkbox>
            </b-form-group>
            <b-button v-if="show_modal_ok_btn" variant="primary" class="mr-2" @click="$store.commit( 'set_conv_special_agreement', true );">Continua</b-button>
            <b-button variant="warning" :to="{ name : 'menu' }">Torna alla home</b-button>
          </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'DiscalimerCondizioni',
  data () {
    return {
      // Checkbox per l'accettazione delle condizioni.
      conditions_checkbox : false
    }
  },
  computed : {
    /**
     * La visualizzazione della modale delle condizioni dipende dalla
     * relativa variabile che teniamo nello store. In questo modo l'utente
     * deve accettare l'informativa solo una volte durante la sessione
     * di lavoro.
     */
    conditions_modal: function () {
      // Torniamo il valore negato perchè esso indica se l'informativa
      // è stata accettata, quindi se non è stata accettata la modale deve vedersi.
      return ! this.$store.state.session_infos.conv_special_agreed;
    },
    /**
     * Visualizza o meno il bottone di ok della modale informativa
     * in base al valore della sua checkbox.
     */
    show_modal_ok_btn: function () {
      return this.conditions_checkbox === true ? true : false;
    }
  }
}
</script>


<style scoped></style>